// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__MicroFrontendContainer__microAppContainer{height:inherit;min-height:inherit;min-width:inherit;width:inherit}", "",{"version":3,"sources":["webpack://./../../../src/shellSide/MicroFrontendContainer/MicroFrontendContainer.module.scss","webpack://./../../platform/@jutro/micro-frontends/shellSide/MicroFrontendContainer/MicroFrontendContainer.module.css"],"names":[],"mappings":"AAAA,gDAEE,cAAA,CADA,kBAAA,CAEA,iBAAA,CACA,aCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"microAppContainer": "jut__MicroFrontendContainer__microAppContainer"
};
export default ___CSS_LOADER_EXPORT___;
